import { ReportsGenerationRepository  } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: [],
    preview: {},
    workOrders: [],
    windFarms: [],
    windTurbines: [],
    interventions: [],
    gridNumber: {
      before: 4,
      repair_stage: 6,
      after: 2,
      inspection: 6,
      panoramic: 6,
    },
    gridSize: {
      before: 6,
      repair_stage: 4,
      after: 7,
      inspection: 4,
      panoramic: 4,
    }
  },
  mutations: {
    SET_VAR (state, params) {
      state[params.key] = params.value
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.getAll(obj)
          .then(response => {
            const data = response.data.data
            commit('SET_VAR', { key: 'list', value: data })
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    get (context, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.get(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    create (context, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.create(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    createVersion (context, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.createVersion(obj)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, obj) {      
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.update(obj)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.delete(obj)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    },
    deleteVersion (context, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.deleteVersion(obj)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    },
    preview ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.preview(obj)
          .then((response) => {
            const data = response.data.data
            commit('SET_VAR', { key: 'preview', value: data })
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    workOrders ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.workOrders(obj)
          .then((response) => {
            const data = response.data.data
            commit('SET_VAR', { key: 'workOrders', value: data })
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    windFarms ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.windFarms(obj)
          .then((response) => {
            const data = response.data.data
            commit('SET_VAR', { key: 'windFarms', value: data })
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    windTurbines ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.windTurbines(obj)
          .then((response) => {
            const data = response.data.data
            commit('SET_VAR', { key: 'windTurbines', value: data })
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    interventions ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        ReportsGenerationRepository.interventions(obj)
          .then((response) => {
            const data = response.data.data
            commit('SET_VAR', { key: 'interventions', value: data })
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    }
  }
}
